import "../Tweets.css";
import { useEffect, useState } from "react";
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import { getCsvData } from "../../../utils/functions/getCsvData";
import TEXT from "../../../utils/text/prensa.json";
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

export default function DiscussionRetorno({
  selectedCountry,
  countryName,
  countryOptions,
  setImg1,
  setImg2,
  setImg3,
  setImg4,
  setImg5,
  setImg6,
}) {
  const { language } = useCurrentLanguage();

  const [data_res, setData_res] = useState([]);

  // REMOVED: dataRetSankey and dataRetCountriesSankey because they are unused/commented out
  const [dataTopicsTop3, setDataTopicsTop3] = useState([]);
   const [dataTopicsXenoTop3, setDataTopicsXenoTop3] = useState([]);
  const [dataTematicaImpacto, setDataTematicaImpacto] = useState([]);
  const [dataTematicaOrigen, setDataTematicaOrigen] = useState([]);
  const [dataTematicaDestino, setDataTematicaDestino] = useState([]);
  const [dataDestino, setDataDestino] = useState([]);

  const [imgUrl1, setImgUrl1] = useState("");
  const [imgUrl5, setImgUrl5] = useState("");

  useEffect(() => {
    processData_res();
    processDataTop3();
    processDataXenoTop3();
    //processDataRetSankey("2023", 4);
    //processDataRetCountriesSankey("2023", 4);
    //processDataTematica();
    //processDataTematicaOrigen();
    //processDataTematicaDestino();
    //processDataDestino();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  useEffect(() => {
    setImg1(imgUrl1);
    setImg5(imgUrl5);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl1, imgUrl5]);

  const processData_res = async () => {
    let df1 = await getCsvData(`/data/retorno/responzability_3m.csv`);
    let dates = [];
    let values = [];
    let values2 = [];

    df1.forEach((e) => {
      dates.push(formatTrimesterLabel(e.date, language));
      values.push(parseFloat(e.victima));
      values2.push(parseFloat(e.responzable));
    });

    // We keep the logic but the state is set to empty as per your original code
    setData_res([]);
  };

  // eslint-disable-next-line no-unused-vars
  const processDataRetSankey = async (selectedYear, selectedTrimester) => {
    await processSankey(
      selectedYear,
      selectedTrimester,
      `/data/retorno/sankey_ret_trim.csv`
    );
    // setDataRetSankey(temp); // Unused state removed
  };

  // eslint-disable-next-line no-unused-vars
  const processDataRetCountriesSankey = async (
    selectedYear,
    selectedTrimester
  ) => {
    await processSankey(
      selectedYear,
      selectedTrimester,
      `/data/retorno/sankey_ret_paises.csv`
    );
    // setDataRetCountriesSankey(temp); // Unused state removed
  };

  const processSankey = async (selectedYear, selectedTrimester, csvFile) => {
    let df = await getCsvData(csvFile);

    let years = [];
    df.forEach((e) => {
      if (!years.includes(e.year)) years.push(e.year);
    });
    let yearOptions = [];
    years.forEach((e) => {
      yearOptions.push({ code: e, label: e });
    });

    let trimesters = [];
    df.forEach((e) => {
      if (!trimesters.includes(e.trimester) && e.year === selectedYear)
        trimesters.push(e.trimester);
    });

    let trimesterOptions = [];
    trimesters.forEach((e) => {
      trimesterOptions.push({ code: `T${e}`, label: `T${e}` });
    });

    if (selectedTrimester === -1)
      selectedTrimester = parseInt(trimesters[trimesters.length - 1]);

    df = df.filter(
      (row) =>
        row.year === selectedYear &&
        row.trimester === selectedTrimester.toString()
    );

    let sourceIndex = "source";
    let targetIndex = "target";
    let valueIndex = "value";
    let percentageIndex = "percentage";

    let nodeValuesMap = new Map();
    df.forEach((e) => {
      let source = e[sourceIndex];
      let target = e[targetIndex];
      let value = parseFloat(e[valueIndex]);

      if (!nodeValuesMap.has(source)) nodeValuesMap.set(source, 0);
      if (!nodeValuesMap.has(target)) nodeValuesMap.set(target, 0);

      nodeValuesMap.set(source, nodeValuesMap.get(source) + value);
      nodeValuesMap.set(target, nodeValuesMap.get(target) + value);
    });

    let nodeValues = Array.from(nodeValuesMap, ([name, value]) => ({
      name,
      value,
    }));
    nodeValues.sort((a, b) => b.value - a.value);
    let topNodes = nodeValues.slice(0, 11);
    let topNodeNames = topNodes.map((node) => node.name);

    let links = [];
    df.forEach((e) => {
      if (
        topNodeNames.includes(e[sourceIndex]) &&
        topNodeNames.includes(e[targetIndex])
      ) {
        let tempLink = {
          source: e[sourceIndex],
          target: e[targetIndex],
          value: parseFloat(e[valueIndex]).toFixed(2),
        };
        if (e[percentageIndex]) {
          tempLink.percentage = parseFloat(e[percentageIndex]).toFixed(2);
        }
        links.push(tempLink);
      }
    });

    let nodes = topNodes.map((node) => ({ name: node.name }));

    let temp = [
      {
        id: "q1",
        data: nodes,
        links: links,
        years: yearOptions,
        trimesters: trimesterOptions,
        selectedYear: selectedYear,
        selectedTrimester: `T${selectedTrimester}`,
        rotate: false,
        graphType: "sankey",
        hasOptions: true,
        isPercentage: true,
      },
    ];

    return temp;
  };

  const processDataTop3 = async () => {
    let df1 = await getCsvData(`/data/retorno/retorno_gender_topics_top3_3m.csv`);
    
      let tempDf1 = [];
      let tempDates = [];
    console.clear();
    //selectedCountry = 'all';
    if (selectedCountry !== "NAC") {
      df1 = df1.filter((row) => row.country === 'all' /*selectedCountry*/);
    } else {
      df1 = df1.filter((row) => row.country === "all");
      
      df1.forEach((e) => {
        if (!tempDates.includes(e.date)) {
          tempDates.push(e.date);
          tempDf1.push(e);
        } else {
          let index = tempDates.indexOf(e.date);
          tempDf1[index].seguridad =
            (parseFloat(tempDf1[index].seguridad) + parseFloat(e.seguridad)) /
              2 || 0;
          tempDf1[index].servicios =
            (parseFloat(tempDf1[index].servicios) + parseFloat(e.servicios)) /
              2 || 0;
          tempDf1[index].empleo =
            (parseFloat(tempDf1[index].empleo) + parseFloat(e.empleo)) / 2 || 0;
          tempDf1[index].politicas =
            (parseFloat(tempDf1[index].politicas) + parseFloat(e.politicas)) /
              2 || 0;
          tempDf1[index].transito =
            (parseFloat(tempDf1[index].transito) + parseFloat(e.transito)) /
              2 || 0;
        }
      });
      df1 = tempDf1;
    }

    let dates = [];
    let valServ = [];
    let valTran = [];
    let valEmp = [];
    let valSeg = [];
    let valPol = [];
    // REMOVED: Unused local 'temp' variable assignment
    //setDataTopicsTop3(df1);

    tempDates.forEach((date) => {
      dates.push(formatTrimesterLabel(date));
      const d = tempDf1.filter((row) => row.date === date)[0];
  
      valServ.push(d.servicios);
      valTran.push(d.transito);
      valEmp.push(d.empleo);
      valSeg.push(d.seguridad);
      valPol.push(d.politicas);
    });

    console.log([dates, valServ, valTran, valEmp, valPol,valSeg])
    setDataTopicsTop3([
      {
        id: "q_tematica",
        data: [dates, valServ, valTran, valEmp, valSeg, valPol],
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Derechos y Servicios", "Transito","Empleo", "Seguridad", "Políticas"]
            : ["Rights & Services","Transit","Empleo", "Security", "Policies"],
        updateTotrimester: false,
        useColors: false,
      },
    ]);
    
  };

   const processDataXenoTop3 = async () => {
    let df1 = await getCsvData(`/data/retorno/retorno_xeno_topics_top3_3m.csv`);
      let tempDf1 = [];
      let tempDates = [];
    console.clear();
    //selectedCountry = 'all';
    if (selectedCountry !== "NAC") {
      df1 = df1.filter((row) => row.country === 'all' /*selectedCountry*/);
    } else {
      df1 = df1.filter((row) => row.country === "all");
      
      df1.forEach((e) => {
        if (!tempDates.includes(e.date)) {
          tempDates.push(e.date);
          tempDf1.push(e);
        } else {
          let index = tempDates.indexOf(e.date);
          tempDf1[index].seguridad =
            (parseFloat(tempDf1[index].seguridad) + parseFloat(e.seguridad)) /
              2 || 0;
          tempDf1[index].servicios =
            (parseFloat(tempDf1[index].servicios) + parseFloat(e.servicios)) /
              2 || 0;
          tempDf1[index].empleo =
            (parseFloat(tempDf1[index].empleo) + parseFloat(e.empleo)) / 2 || 0;
          tempDf1[index].politicas =
            (parseFloat(tempDf1[index].politicas) + parseFloat(e.politicas)) /
              2 || 0;
          tempDf1[index].transito =
            (parseFloat(tempDf1[index].transito) + parseFloat(e.transito)) /
              2 || 0;
        }
      });
      df1 = tempDf1;
    }

    let dates = [];
    let valServ = [];
    let valTran = [];
    let valEmp = [];
    let valSeg = [];
    let valPol = [];
    // REMOVED: Unused local 'temp' variable assignment
    //setDataTopicsTop3(df1);

    tempDates.forEach((date) => {
      dates.push(formatTrimesterLabel(date));
      const d = tempDf1.filter((row) => row.date === date)[0];
  
      valServ.push(d.servicios);
      valTran.push(d.transito);
      valEmp.push(d.empleo);
      valSeg.push(d.seguridad);
      valPol.push(d.politicas);
    });

    console.log([dates, valServ, valTran, valEmp, valPol,valSeg])
    setDataTopicsXenoTop3([
      {
        id: "q_tematica",
        data: [dates, valServ, valTran, valEmp, valSeg, valPol],
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Derechos y Servicios", "Transito","Empleo", "Seguridad", "Políticas"]
            : ["Rights & Services","Transit","Empleo", "Security", "Policies"],
        updateTotrimester: false,
        useColors: false,
      },
    ]);
    
  };

  // eslint-disable-next-line no-unused-vars
  const processDataTematica = async () => {
    let df = await getCsvData(`/data/retorno/tematica_impacto.csv`);
    let tempDates = [];
    let tempMap = {};

    df.forEach((row) => {
      if (selectedCountry !== "NAC" && row.country !== selectedCountry) return;
      let date = row.date;
      if (date.includes("/")) {
        const [month, day, year] = date.split("/");
        date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
      const val = parseFloat(row.porcentaje * 100) || 0;
      const cat = row.categoria;

      if (!tempMap[date]) {
        tempDates.push(date);
        tempMap[date] = { destSum: 0, destCount: 0, origSum: 0, origCount: 0 };
      }
      if (cat === "Destino") {
        tempMap[date].destSum += val;
        tempMap[date].destCount += 1;
      } else if (cat === "Origen") {
        tempMap[date].origSum += val;
        tempMap[date].origCount += 1;
      }
    });

    let dates = [];
    let valuesDestino = [];
    let valuesOrigen = [];

    tempDates.forEach((date) => {
      dates.push(formatTrimesterLabel(date));
      const d = tempMap[date];
      valuesDestino.push(d.destCount > 0 ? d.destSum / d.destCount : 0);
      valuesOrigen.push(d.origCount > 0 ? d.origSum / d.origCount : 0);
    });

    let combinedArray = [dates, valuesDestino, valuesOrigen];
    setDataTematicaImpacto([
      {
        id: "q_tematica_impacto",
        data: combinedArray,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es" ? ["Destino", "Origen"] : ["Destination", "Origin"],
        updateTotrimester: false,
        useColors: false,
      },
    ]);
  };

  // eslint-disable-next-line no-unused-vars
  const processDataTematicaOrigen = async () => {
    let df = await getCsvData(`/data/retorno/retorno_tematica_origen.csv`);
    let tempDates = [];
    let tempMap = {};

    // REMOVED: unused KEYS object

    df.forEach((row) => {
      if (selectedCountry !== "NAC" && row.country !== selectedCountry) return;
      let date = row.date;
      if (date && date.includes("/")) {
        const [month, day, year] = date.split("/");
        date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
      const val = parseFloat(row.porcentaje * 100) || 0;
      const cat = row.categoria;

      if (!tempMap[date]) {
        tempDates.push(date);
        tempMap[date] = {
          ecoSum: 0,
          ecoCount: 0,
          condSum: 0,
          condCount: 0,
          segSum: 0,
          segCount: 0,
          polSum: 0,
          polCount: 0,
        };
      }
      if (cat.includes("Economía")) {
        tempMap[date].ecoSum += val;
        tempMap[date].ecoCount += 1;
      } else if (cat.includes("Condiciones")) {
        tempMap[date].condSum += val;
        tempMap[date].condCount += 1;
      } else if (cat.includes("Seguridad")) {
        tempMap[date].segSum += val;
        tempMap[date].segCount += 1;
      } else if (cat.includes("Políticas")) {
        tempMap[date].polSum += val;
        tempMap[date].polCount += 1;
      }
    });

    let dates = [];
    let valEco = [];
    let valCond = [];
    let valSeg = [];
    let valPol = [];

    tempDates.forEach((date) => {
      dates.push(formatTrimesterLabel(date));
      const d = tempMap[date];
      valEco.push(d.ecoCount > 0 ? d.ecoSum / d.ecoCount : 0);
      valCond.push(d.condCount > 0 ? d.condSum / d.condCount : 0);
      valSeg.push(d.segCount > 0 ? d.segSum / d.segCount : 0);
      valPol.push(d.polCount > 0 ? d.polSum / d.polCount : 0);
    });

    console.log([dates, valEco, valCond, valSeg, valPol])
    setDataTematicaOrigen([
      {
        id: "q_tematica_origen",
        data: [dates, valEco, valCond, valSeg, valPol],
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Economía", "Derechos y Servicios", "Seguridad", "Políticas"]
            : ["Economy", "Rights & Services", "Security", "Policies"],
        updateTotrimester: false,
        useColors: false,
      },
    ]);
  };

  // eslint-disable-next-line no-unused-vars
  const processDataTematicaDestino = async () => {
    let df = await getCsvData(`/data/retorno/retorno_tematica_destino.csv`);
    let tempDates = [];
    let tempMap = {};

    df.forEach((row) => {
      if (!row || !row.categoria || !row.date) return;
      if (selectedCountry !== "NAC" && row.country !== selectedCountry) return;
      let date = row.date;
      if (date.includes("/")) {
        const [month, day, year] = date.split("/");
        date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
      const val = parseFloat(row.porcentaje * 100) || 0;
      const cat = row.categoria;

      if (!tempMap[date]) {
        tempDates.push(date);
        tempMap[date] = {
          ecoSum: 0,
          ecoCount: 0,
          condSum: 0,
          condCount: 0,
          segSum: 0,
          segCount: 0,
          polSum: 0,
          polCount: 0,
        };
      }
      if (cat.includes("Economía")) {
        tempMap[date].ecoSum += val;
        tempMap[date].ecoCount += 1;
      } else if (cat.includes("Condiciones")) {
        tempMap[date].condSum += val;
        tempMap[date].condCount += 1;
      } else if (cat.includes("Seguridad")) {
        tempMap[date].segSum += val;
        tempMap[date].segCount += 1;
      } else if (cat.includes("Políticas")) {
        tempMap[date].polSum += val;
        tempMap[date].polCount += 1;
      }
    });

    let dates = [];
    let valEco = [];
    let valCond = [];
    let valSeg = [];
    let valPol = [];

    tempDates.forEach((date) => {
      dates.push(formatTrimesterLabel(date));
      const d = tempMap[date];
      valEco.push(d.ecoCount > 0 ? d.ecoSum / d.ecoCount : 0);
      valCond.push(d.condCount > 0 ? d.condSum / d.condCount : 0);
      valSeg.push(d.segCount > 0 ? d.segSum / d.segCount : 0);
      valPol.push(d.polCount > 0 ? d.polSum / d.polCount : 0);
    });

    setDataTematicaDestino([
      {
        id: "q_tematica_destino",
        data: [dates, valEco, valCond, valSeg, valPol],
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Economía", "Derechos y Servicios", "Seguridad", "Políticas"]
            : ["Economy", "Rights & Services", "Security", "Policies"],
        updateTotrimester: false,
        useColors: false,
      },
    ]);
  };

  // eslint-disable-next-line no-unused-vars
  const processDataDestino = async () => {
    let df = await getCsvData(`/data/retorno/retorno_destino.csv`);
    let tempDates = [];
    let tempMap = {};

    df.forEach((row) => {
      if (!row || !row.pais_destino || !row.date) return;
      if (selectedCountry !== "NAC" && row.country !== selectedCountry) return;
      let date = row.date;
      if (date.includes("/")) {
        const [month, day, year] = date.split("/");
        date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
      const val = parseFloat(row.porcentaje * 100) || 0;
      const dest = row.pais_destino;

      if (!tempMap[date]) {
        tempDates.push(date);
        tempMap[date] = { usaSum: 0, usaCount: 0, mexSum: 0, mexCount: 0 };
      }
      if (dest.includes("EE.UU.") || dest.includes("USA")) {
        tempMap[date].usaSum += val;
        tempMap[date].usaCount += 1;
      } else if (dest.includes("Mexico") || dest.includes("México")) {
        tempMap[date].mexSum += val;
        tempMap[date].mexCount += 1;
      }
    });

    let dates = [];
    let valUsa = [];
    let valMex = [];

    tempDates.forEach((date) => {
      dates.push(formatTrimesterLabel(date));
      const d = tempMap[date];
      valUsa.push(d.usaCount > 0 ? d.usaSum / d.usaCount : 0);
      valMex.push(d.mexCount > 0 ? d.mexSum / d.mexCount : 0);
    });

    setDataDestino([
      {
        id: "q_destino_pais",
        data: [dates, valUsa, valMex],
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName:
          language === "es"
            ? ["Estados Unidos", "México"]
            : ["United States", "Mexico"],
        updateTotrimester: false,
        useColors: false,
      },
    ]);
  };

  // REMOVED: handleYearChange and handleAllTrimesterChange because they are unused

  return (
    <div className="surveys-page-content">
      <div className="surveys-page-graphs">
        <div className="survey-page-full-surveys">
          <div className="full-screen">
            <div className="nl-selector-container"></div>
            <div>
              {dataTopicsTop3.length > 0 && (
                <TweetGraph
                  data={dataTopicsTop3}
                  title={
                    TEXT["topics"]["topics_top3_ret"]["title"][language] +
                    // eslint-disable-next-line no-useless-concat
                    " " + "NCA + Mexico"
                    //countryName
                  }
                  setImgUrl={setImgUrl1}
                />
              )}
                 {dataTopicsXenoTop3.length > 0 && (
                <TweetGraph
                  data={dataTopicsXenoTop3}
                  title={
                    TEXT["sentiment"]["xenophobia_topics"]["title"][language] +
                    // eslint-disable-next-line no-useless-concat
                    " " + "NCA + Mexico"
                    //countryName
                  }
                  setImgUrl={setImgUrl1}
                />
              )}
          
              {dataTematicaOrigen.length > 0 && (
                <TweetGraph
                  data={dataTematicaOrigen}
                  title={
                    (language === "es"
                      ? "Dimensión temática para notas con perspectiva de impacto en país de origen"
                      : "Impact Themes on Country of Origin") +
                    " " +
                    (selectedCountry === "NAC" ? "" : countryName)
                  }
                  setImgUrl={setImgUrl1}
                />
              )}
              {dataTematicaDestino.length > 0 && (
                <TweetGraph
                  data={dataTematicaDestino}
                  title={
                    (language === "es"
                      ? "Dimensión temática para notas con perspectiva de impacto en país de destino"
                      : "Impact Themes on Destination Country") +
                    " " +
                    (selectedCountry === "NAC" ? "" : countryName)
                  }
                  setImgUrl={() => {}}
                />
              )}
              {dataTematicaImpacto.length > 0 && (
                <TweetGraph
                  data={dataTematicaImpacto}
                  title={
                    (language === "es"
                      ? "Notas con perspectiva de impacto en país de origen o país de destino"
                      : "Notes on Origin or Destination Impact") +
                    " " +
                    (selectedCountry === "NAC" ? "" : countryName)
                  }
                  setImgUrl={setImgUrl1}
                />
              )}
              {dataDestino.length > 0 && (
                <TweetGraph
                  data={dataDestino}
                  title={
                    (language === "es"
                      ? "Notas clasificadas por país de destino identificado"
                      : "Notes by Destination Country") +
                    " " +
                    (selectedCountry === "NAC" ? "" : countryName)
                  }
                  setImgUrl={() => {}}
                />
              )}
              {data_res.length > 0 && (
                <TweetGraph
                  data={data_res}
                  title={
                    TEXT["sentiment"]["responsabilization_ret"]["title"][
                      language
                    ] +
                    " " +
                    countryName +
                    TEXT["sentiment"]["responsabilization"]["title2"][language]
                  }
                  setImgUrl={setImgUrl5}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
